import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';
import { ToastService } from '../../components/toast/toast.service';
import { PatientService } from '../../services/patient.service';
import { Patient } from '../../models/patient.model';

@Component({
  selector: 'lowy-manage-secondary-ids',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Edit Patient Secondary IDs</div>
      <div class="subheading">Update a patiends seciondary IDs / A Number</div>
      <div class="oh sn"></div>
      <form [formGroup]="idLookupForm" (ngSubmit)="lookupId()" *ngIf="!patientId">
        <mat-form-field>
          <input matInput placeholder="Patient ID" formControlName="patientId" type="text">
          <span *ngIf="patientIdErr">{{patientIdErr}}</span>
        </mat-form-field>
      </form>
      <div class="seperator" *ngIf="!patientId"></div>
      <div class="button-row" *ngIf="!patientId">
        <span (click)="idLookupForm.valid && lookupId()" [ngClass]="{disabled: idLookupForm.invalid}">lookup</span>
      </div>
      <form [formGroup]="updateIdForm" (ngSubmit)="updateIds()" *ngIf="patientId">
        <p>Update patient: {{patientId}}</p>
        <mat-form-field>
          <input matInput placeholder="Patient ID #2 / A Number" formControlName="patientId2" type="text">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Patient ID #3 / Site ID" formControlName="patientId3" type="text">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Patient ID #4 / ID 4" formControlName="patientId4" type="text">
        </mat-form-field>
      </form>
      <div class="seperator" *ngIf="patientId"></div>
      <div class="button-row" *ngIf="patientId">
        <span (click)="cancel()">cancel</span>
        <span (click)="updateIdForm.valid && updateIds()" [ngClass]="{disabled: updateIdForm.invalid}">update</span>
      </div>
    </div>
  </lowy-modal>
  `,
  providers: [ PatientService ]
})
export class ManageSecondaryPatientIdsComponent {
  idLookupForm: FormGroup;
  updateIdForm: FormGroup;

  @ViewChild('modal') modal: ModalComponent;

  public patientId: string;
  public patient: Patient;
  public patientIdErr: string;

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private patientService: PatientService
  ) {
    this.buildForm();
  }

  public open() {
    this.buildForm();
    this.patientId = null;
    this.patient = null;
    this.patientIdErr = null;
    this.modal.open();
  }

  async buildForm() {
    this.idLookupForm = this.formBuilder.group({
      patientId: ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.updateIdForm = this.formBuilder.group({
      patientId2: [''],
      patientId3: [''],
      patientId4: [''],
    });
  }

  async lookupId() {
    try {
      this.patientId = await this.patientService.testAndNormalizePatientId(this.idLookupForm.value.patientId);
      this.patient = await this.patientService.getPatient(this.patientId);
      this.updateIdForm.controls['patientId2'].setValue(this.patient.patId2);
      this.updateIdForm.controls['patientId3'].setValue(this.patient.patId3);
      this.updateIdForm.controls['patientId4'].setValue(this.patient.patId4);
    }
    catch (err) {
      this.patientIdErr = err.message || 'Invalid Patient ID';
    }
  }

  async updateIds() {
    try {
      await this.patientService.updateSecondaryIds(this.patientId, {
        patId2: this.updateIdForm.value.patientId2,
        patId3: this.updateIdForm.value.patientId3,
        patId4: this.updateIdForm.value.patientId4
      });
      this.modal.close();
      this.toastService.throwToast('Patient secondary IDs change successful');
    }
    catch (err) {
      this.modal.close();
      this.toastService.throwToast('Error changing secondary IDs: ' + (err.message ? err.message : err));
    }
  }

  cancel() {
    this.modal.close();
    this.buildForm();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/header/manage-secondary-ids.component.ts